const dto = JSON.parse(document.getElementById("orange-telesurveillance-simulator-page").dataset.dto);

let selectedOfferId = dto.context.selectedOfferId;
let fromXSell = dto.context.fromXSell;
let sequencesMap = new Map();
dto.sequencesList.map((offerSequence) => {
    sequencesMap.set(offerSequence.offerId, offerSequence.sequence)
});

let currentSequence;
let currentStepId;
let currentIndex;
let initialIndex;
let maxIndex;
let contexteProduit;

let optionStates = {};
dto.offersList.forEach(
    offer => {
        offer.options.forEach(
            option => {
                optionStates[option.elementId] = false;
            }
        )
    }
);
let optionsCounter = 0;
let selectedOffer;
let discountCode;

let totalPrice;
let totalPriceWithoutDiscount;
let offerPrice;
let offerInitialPrice;

// code promo : éléments html
const discountCodeElement = document.getElementById("discount-code");
const discountCodeInputElement = document.getElementById("discount-code-input");
const discountCodeErrorElement = document.getElementById("discount-code-error");
const discountCodeAddElement = document.getElementById("discount-code-add");
const discountCodeSpinnerElement = document.getElementById("discount-code-spinner");
const discountCodeSuccessElement = document.getElementById("discount-code-success");
const discountCodeSuccessTextElement = document.getElementById("discount-code-success-text");
const discountCodeRemoveElement = document.getElementById("discount-code-remove");
const discountCodeLinkElement = document.getElementById("discount-code-header");

// tms
const tmsLandingCategory = 'landing_page';
const tmsDiscountCodeAction = 'code_promotionnel';

function tmsTag(category, action, label) {
    return {
        category: category,
        action: action,
        label: label
    }
}

function showElement(element) {
    element.classList.remove('d-none');
}

function hideElement(element) {
    element.classList.add('d-none');
}

function showStep(stepId) {
    window.scrollTo(0, 0);
    const progressbarValue = maxIndex ? (currentIndex + 2) * 100 / (maxIndex + 3) : 15;
    document.getElementById('progressbar-' + stepId).setAttribute('value', progressbarValue);
    showElement(document.getElementById(stepId));
}

function hideStep(stepId) {
    hideElement(document.getElementById(stepId));
}

function formatPrice(priceInCents) {
    const euros = Math.floor(priceInCents / 100);
    const cents = priceInCents % 100;
    return cents === 0
        ? euros.toString()
        : `${euros},${cents.toString().padStart(2, '0')}`;
}

function updateTotalPrice() {
    // mini-panier
    document.getElementById('cart-total-recurringPrice').innerHTML = safeHTML(formatPrice(totalPrice) + "\u202F€ /mois");
    let srOnly = formatPrice(totalPrice) + "€ par mois";
    if (totalPriceWithoutDiscount === totalPrice) {
        // mini-panier - total mensuel
        document.getElementById('cart-total-priceDetails').innerHTML = safeHTML("");
        // bloc principal
        document.getElementById('firstColumn-totalPrice').innerHTML = safeHTML(
            `<div class="col-12 p-0">
            <div class="ob1-price" data-ob1-component="Price">
                <p class="visually-hidden">${srOnly}</p>
                <p aria-hidden="true">
                    <span class="ob1-price-amount">${formatPrice(totalPrice)}\u202F€ </span>
                    <span class="ob1-price-by-month">/mois</span>
                    <span class="ob1-price-promo-duration">${getFirstColumnTotalFees()}</span>
                </p>
            </div>
        </div>`);
    } else {
        srOnly = srOnly + " puis " + formatPrice(totalPriceWithoutDiscount) + "€ par mois à la fin de vos promotions";
        // mini-panier
        document.getElementById('cart-total-priceDetails').innerHTML = safeHTML(
            " puis " + formatPrice(totalPriceWithoutDiscount) + "\u202F€ /mois à la fin de vos promotions");
        // bloc principal
        document.getElementById('firstColumn-totalPrice').innerHTML = safeHTML(
            `<div class="col-12 p-0">
            <div class="ob1-price" data-ob1-component="Price">
                <p class="visually-hidden">${srOnly}</p>
                <p aria-hidden="true">
                    <span class="ob1-price-amount">${formatPrice(totalPrice)}\u202F€ </span>
                    <span class="ob1-price-by-month">/mois</span>
                    <span class="ob1-price-promo-duration">
                        <span>puis</span>
                        <span class="ob1-price-promo-duration-by-month">${formatPrice(totalPriceWithoutDiscount)}\u202F€ /mois</span>
                        <span>à la fin de vos promotions</span>
                    </span>
                    <span class="ob1-price-promo-duration">${getFirstColumnTotalFees()}</span>
                </p>
            </div>
        </div>`);

    }

    // mini-panier
    document.getElementById('cart-total-srOnly').innerHTML = safeHTML(srOnly);
    // mini-panier - total frais
    if (selectedOffer.fees != null && !selectedOffer.fees.subscriptionIsFree) {
        showElement(document.getElementById('cart-total-fees'));
        document.getElementById('cart-total-fees-srOnly').innerHTML = safeHTML(selectedOffer.fees.subscriptionPrice.srOnly);
        document.getElementById('cart-total-fees-amount').innerHTML = safeHTML(selectedOffer.fees.subscriptionPrice.price);
    } else {
        hideElement(document.getElementById('cart-total-fees'));
    }

}

function getSrOnly(price, priceDetails) {
    const concat = priceDetails ?
        formatPrice(price) + " " + formatPrice(priceDetails) :
        formatPrice(price);
    return concat.replaceAll("/", "par ");
}

function updateOfferPrice(srOnly, price, priceDetails) {
    document.getElementById('cart-offerPrice-srOnly').innerHTML = safeHTML(srOnly);
    document.getElementById('cart-offerPrice-price').innerHTML = safeHTML(price);
    document.getElementById('cart-offerPrice-priceDetails').innerHTML = safeHTML(priceDetails);
}

function updateFeesPrice(feesLabel, srOnly, amount) {
    document.getElementById('cart-feesLabel').innerHTML = safeHTML(feesLabel);
    document.getElementById('cart-feesPrice-srOnly').innerHTML = safeHTML(srOnly);
    document.getElementById('cart-feesPrice-amount').innerHTML = safeHTML(amount);
}

function updateOfferPriceWithDiscount(offerPrice, offerInitialPrice, discountDuration) {
    const price = formatPrice(offerPrice) + "\u202F€ /mois";
    const priceDetails = (discountDuration === 0) ?
        "au lieu de " + formatPrice(offerInitialPrice) + "\u202F€ /mois" :
        "pendant " + discountDuration + " mois puis " + formatPrice(offerInitialPrice) + "\u202F€ /mois";
    const srOnly = getSrOnly(price, priceDetails);
    updateOfferPrice(srOnly, price, priceDetails);
}

function updateOfferPriceWithoutDiscount(offerPrice) {
    const price = formatPrice(offerPrice) + "\u202F€ /mois";
    const srOnly = getSrOnly(price, null);
    updateOfferPrice(srOnly, price, null);
}

function getFirstColumnTotalFees() {
    if (selectedOffer.fees == null) {
        return ""
    } else {
        const price = selectedOffer.fees.subscriptionIsFree ? "offerts" : selectedOffer.fees.subscriptionPrice.price;
        return selectedOffer.fees.subscriptionFeesLabel.concat(" ", price);
    }
}

function initOfferPrice() {
    offerPrice = parseInt(selectedOffer.prixDto.price * 100);
    offerInitialPrice = parseInt(selectedOffer.prixDto.initialPrice * 100);
    if (selectedOffer.hasDiscount) {
        updateOfferPriceWithDiscount(offerPrice, offerInitialPrice, selectedOffer.prixDto.duration);
    } else {
        updateOfferPriceWithoutDiscount(offerPrice);
    }
}

function initStates(offerId) {

    selectedOffer = dto.offersList.find(of => of.id === offerId);

    // affichage du prix dans l'offre recommendée
    showElement(document.getElementById('recommendedOffer-' + selectedOffer.id));
    // affichage de l'offre dans le mini-panier
    document.getElementById('cart-offerName').innerHTML = safeHTML(selectedOffer.name);
    initOfferPrice();
    totalPrice = offerPrice;
    totalPriceWithoutDiscount = offerInitialPrice;
    // affichage des frais si besoin
    if (selectedOffer.fees != null) {
        showElement(document.getElementById('cart-feesBlock'));
        updateFeesPrice(
            selectedOffer.fees.subscriptionFeesLabel,
            selectedOffer.fees.subscriptionPrice.srOnly,
            selectedOffer.fees.subscriptionPrice.price
        );
    }
    // affichage du prix total (mini-panier et bloc principal)
    updateTotalPrice();
    // ajout eventuel d'un code promo
    if (dto.context.discountCode.length !== 0) {
        showElement(discountCodeElement);
        discountCodeInputElement.value = dto.context.discountCode;
        showElement(discountCodeAddElement);
        addDiscountCode(dto.context.discountCode);
    }

    // raz de l'affichage des options
    document.querySelectorAll('.radio-input-answers').forEach(e => e.checked = false);
    dto.offersList.forEach(offer => {
        offer.options.forEach(option => {
            optionStates[option.elementId] = false;
            // gestion du switch
            document.getElementById('checkbox-' + option.elementId).checked = false;
            hideElement(document.getElementById('option-' + option.elementId));
        });
    });
    selectedOffer.options.forEach(option => {
        showElement(document.getElementById('option-' + option.elementId));
    });
    optionsCounter = 0;
    hideElement(document.getElementById('cart-optionsBlock'))
    document.getElementById('cart-optionsList').innerHTML = safeHTML(
        `<div id="cart-optionsList" class="row d-none" ></div>`);
}

function addOption(elementId) {
    const option = selectedOffer.options.find(op => op.elementId === elementId).cartOptionDto;
    optionStates[elementId] = true;
    // gestion du switch
    document.getElementById('checkbox-' + elementId).checked = true;
    optionsCounter++;
    // affichage du bloc option dans le mini-panier si besoin
    if (optionsCounter === 1) showElement(document.getElementById('cart-optionsBlock'));
    // ajout de la ligne dans le mini-panier
    const recurringPriceInCents = option.discountedRecurringPriceInCents != null ? option.discountedRecurringPriceInCents : option.recurringPriceInCents
    const displayedRecurringPrice = option.free ? "Offert" : formatPrice(recurringPriceInCents);
    const recurringPriceSrOnly = option.free ? `Offert au lieu de ${formatPrice(option.recurringPriceInCents)} euros par mois` : `${formatPrice(recurringPriceInCents)} euros par mois`;
    const priceByMonthLabel = option.free ? "" : " € /mois";
    const discountDuration = option.discountDuration ? `pendant ${option.discountDuration.duration} mois` : "";
    const initialRecurringPriceInCents = option.foreverDiscounted ? `au lieu de ${formatPrice(option.recurringPriceInCents)} € /mois` : (option.discountDuration ? `puis ${formatPrice(option.recurringPriceInCents)} € /mois` : "");

    $("#cart-optionsList").append(
        `<div class="col-12" id="addedOption${elementId}" class="js-cart-added-options">
            <div class="row p-0">
                <div class="col-8 lead fw-bold text-gray3 d-flex align-items-center">
                    <p class="mb-0 fw-bold">${option.label}</p>
                </div>
                <div class="col-4 d-flex align-items-center justify-content-end text-end">
                    <div id="prix${elementId}" class="ob1-price ob1-price-mini" data-ob1-component="Price" data-ref-price="Price${elementId}">
                        <p class="visually-hidden">${recurringPriceSrOnly}</p>
                        <p aria-hidden="true">
                            <span class="ob1-price-amount">${displayedRecurringPrice}</span><span class="ob1-price-by-month">${priceByMonthLabel}</span>
                            <span class="ob1-price-promo-duration">
                              <span class="${option.discountDuration != null ? '' : 'hidden'}">${discountDuration}</span>
                              <span class="ob1-price-promo-duration-by-month ${initialRecurringPriceInCents !== '' ? '' : 'hidden'}">${initialRecurringPriceInCents}</span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>`
    );

    // Modification du prix total
    if (option.discountedRecurringPriceInCents !== undefined) {
        totalPrice += option.discountedRecurringPriceInCents;
    } else {
        totalPrice += option.recurringPriceInCents;
    }
    if (option.foreverDiscounted) {
        totalPriceWithoutDiscount += option.discountedRecurringPriceInCents;
    } else {
        totalPriceWithoutDiscount += option.recurringPriceInCents;
    }
    updateTotalPrice();
}

function removeOption(elementId) {
    const option = selectedOffer.options.find(op => op.elementId === elementId).cartOptionDto;
    optionStates[elementId] = false;
    // gestion du switch
    document.getElementById('checkbox-' + elementId).checked = false;
    // suppression de l'affichage du bloc option dans le mini-panier si besoin
    optionsCounter--;
    if (optionsCounter === 0) hideElement(document.getElementById('cart-optionsBlock'));
    // suppression de la ligne dans le mini-panier
    $(`#addedOption${elementId}`).remove();

    // Modification du prix total
    if (option.discountedRecurringPriceInCents !== undefined) {
        totalPrice -= option.discountedRecurringPriceInCents;
    } else {
        totalPrice -= option.recurringPriceInCents;
    }
    if (option.foreverDiscounted) {
        totalPriceWithoutDiscount -= option.discountedRecurringPriceInCents;
    } else {
        totalPriceWithoutDiscount -= option.recurringPriceInCents;
    }
    updateTotalPrice();
}

function addDiscountCode(discountCodeParam) {
    const addUrl = document.getElementById("discount-code-add").dataset.addUrl;
    $.ajax({
        method: "PUT",
        timeout: myshop.wsTimeout,
        url: `${addUrl}/${selectedOffer.offerServiceTemplateId}/${discountCodeParam}`,
        beforeSend: function () {
            showElement(discountCodeSpinnerElement);
            hideElement(discountCodeSuccessElement);
        }
    }).done(function (response) {
        if (response.status === 'OK') {
            discountCode = discountCodeParam;
            // update des prix
            const discountValue = (response.discountType === 'AMOUNT') ? response.discountValue : offerPrice * response.discountValue;
            const oldOfferPrice = offerPrice;
            offerPrice = offerInitialPrice - discountValue;
            updateOfferPriceWithDiscount(offerPrice, offerInitialPrice, response.discountDuration);
            totalPrice += offerPrice - oldOfferPrice;
            updateTotalPrice();
            // update de l'affichage des éléments de la zone code promo
            hideElement(discountCodeSpinnerElement);
            hideElement(discountCodeAddElement);
            hideElement(discountCodeErrorElement);
            discountCodeSuccessTextElement.innerHTML = safeHTML(response.validCodeMessage);
            showElement(discountCodeSuccessElement);
            hideElement(discountCodeInputElement);
            discountCodeInputElement.classList.remove('is-invalid');
            discountCodeInputElement.classList.add('form-control-empty');
            Tms.link(tmsTag(tmsLandingCategory, tmsDiscountCodeAction, 'ok'));
        } else if (response.status === 'KO') {
            hideElement(discountCodeSpinnerElement);
            showElement(discountCodeErrorElement);
            discountCodeInputElement.classList.remove('form-control-empty');
            discountCodeInputElement.classList.add('is-invalid');
            Tms.link(tmsTag(tmsLandingCategory, tmsDiscountCodeAction, 'ko'));
        }
    }).fail(function () {
        hideElement(discountCodeSpinnerElement);
        showElement(discountCodeErrorElement);
        discountCodeInputElement.classList.remove('form-control-empty');
        discountCodeInputElement.classList.add('is-invalid');
        Tms.link(tmsTag(tmsLandingCategory, tmsDiscountCodeAction, 'ko'));
    });
}

// initialisation :
function initialisation() {
    // Si la clé de conf isUnfolded est à true, le code promo doit être déplié à l'affichage de la page :
    if (discountCodeLinkElement.getAttribute("data-is-unfolded") === "true") {
        discountCodeLinkElement.classList.remove("collapsed");
        discountCodeLinkElement.setAttribute("aria-expanded", "true");
        showElement(discountCodeElement);
    }
    contexteProduit = "";
    if (selectedOfferId === undefined) {
        currentStepId = dto.stepsList[0].id;
        currentIndex = -1;
        initialIndex = -1;
        // spécifique étape choix de l'offre : on supprime la classe radio-input-answers
        // qui sert pour un reset éventuel des réponses plus tard
        document.querySelectorAll('input[name="radio-' + currentStepId + '"]')
            .forEach(e => e.classList.remove('radio-input-answers'));
    } else {
        currentSequence = sequencesMap.get(selectedOfferId);
        maxIndex = currentSequence.length - 1;
        initialIndex = 0;
        initStates(selectedOfferId);
        if (fromXSell) {
            currentIndex = maxIndex + 1;
            currentStepId = 'resultats';
            if (dto.context.optionIds.length !== 0) {
                dto.context.optionIds.forEach(optionId => {
                    const optionToAdd = selectedOffer.options.find(option => option.paramName === optionId);
                    if (optionToAdd !== undefined) addOption(optionToAdd.elementId)
                });
            }
            resultsTrackingEvent();
        } else {
            currentIndex = 0;
            currentStepId = currentSequence[currentIndex];
        }

    }
    showStep(currentStepId);
}

// boutons 'continuer' :
document.querySelectorAll('.step-continue-button')
    .forEach(button =>
        button.addEventListener("click", () => {
            if (document.querySelector('input[name="radio-' + currentStepId + '"]:checked') !== null) {
                const answer = document.querySelector('input[name="radio-' + currentStepId + '"]:checked').value;
                if (currentIndex === -1) {
                    // raz du prix de l'offre dans le bloc principal
                    if (selectedOfferId !== undefined) {
                        hideElement(document.getElementById('recommendedOffer-' + selectedOffer.id));
                    }
                    // valorisation de l'offre en fonction de la réponse (à améliorer : on doit pouvoir s'affranchir des id 'en dur')
                    selectedOfferId = (answer === '0') ? "OS02" : "OS01";
                    // initialisation liée à l'offre choisie
                    initStates(selectedOfferId);
                    // gestion des étapes
                    currentSequence = sequencesMap.get(selectedOfferId);
                    maxIndex = currentSequence.length - 1;
                    currentIndex = 0;
                    // effacement de l'étape choix de l'offre
                    hideStep(currentStepId);
                    currentStepId = currentSequence[currentIndex];
                    // affichage de la 1ère étape de l'offre
                    showStep(currentStepId);
                } else if (currentIndex <= maxIndex) {
                    // ajout ou suppression de l'option
                    dto.stepsList.find(step => step.id === currentStepId)
                        .answerOptions.forEach(answOpt => {
                        const elementId = answOpt.optionId + '_' + selectedOffer.id
                        if (answOpt.answerId === answer) {
                            if (optionStates[elementId] === false) {
                                addOption(elementId);
                            }
                        } else {
                            if (optionStates[elementId] === true) {
                                removeOption(elementId)
                            }
                        }
                    });
                    // effacement de l'étape en cours
                    hideStep(currentStepId);
                    currentIndex++;
                    if (currentIndex !== maxIndex + 1) {
                        currentStepId = currentSequence[currentIndex];
                    } else {
                        currentStepId = 'resultats';
                        resultsTrackingEvent();
                        if (Object.entries(optionStates).filter(([k, v]) => v === true).length !== 0) {
                            expandAccordionOptions();
                            changeAccordionHeadingTitle(dto.optionChoicesBlock.title);
                        }
                        orderOptions();
                    }
                    // affichage de l'étape suivante (y compris la page résultats)
                    showStep(currentStepId);
                }
            } else {
                // pas de sélection : affichage du message d'erreur
                document.getElementById('items-list-' + currentStepId).classList.toggle("is-invalid", true);
            }
        })
    );

function orderOptions() {
    const sequenceOptions = currentSequence
        .map(stepId => dto.stepsList.find(step => step.id === stepId))
        .filter(step => step && Array.isArray(step.answerOptions) && step.answerOptions.length > 0)
        .map(step => `${step.answerOptions[0].optionId}_${selectedOffer.id}`);

    let orderedOptions = selectedOffer.options
        .sort((a, b) => optionStates[b.elementId] - optionStates[a.elementId]
            || sequenceOptions.indexOf(a.elementId) - sequenceOptions.indexOf(b.elementId));
    orderedOptions.forEach((option, index) => {
        document.getElementById('option-' + option.elementId).style.order = index;
    });
}

function expandAccordionOptions() {
    document.getElementById('accordionHeading').classList.remove('collapsed');
    document.getElementById('accordionHeading').ariaExpanded = "true";
    document.getElementById('accordionCollapse').classList.add('show')
}

function changeAccordionHeadingTitle(text) {
    document.getElementById('accordionTitle').innerText = text;
}

function resultsTrackingEvent() {
    const contexteProduit =
        currentSequence.map(stepFromSequence => {
            const optionStep = dto.stepsList.find(step => step.id === stepFromSequence);
            if (optionStep && optionStep.answerOptions && optionStep.answerOptions[0]) {
                const optionElementId = optionStep.answerOptions[0].optionId + '_' + selectedOffer.id;
                if (optionElementId) {
                    return stepFromSequence + ":" + optionStates[optionElementId];
                }
            }
        })
            .filter(Boolean)
            .join(";");
    Tms.view({
        id_tracking: dto.resultsPageIdTracking,
        contexte_produit: contexteProduit
    });
}

// clic sur le titre de l'accordéon des options choisies : changement du titre
const accordionTitle = document.getElementById('accordionTitle');
if (accordionTitle) {
    accordionTitle.addEventListener("click", () => {
        changeAccordionHeadingTitle(dto.optionChoicesBlock.title);
    });
}

// clic sur réponses : suppression du message d'erreur
document.querySelectorAll('input[id^="answer-"]')
    .forEach(answer =>
        answer.addEventListener("click", () => {
            document.getElementById('items-list-' + currentStepId).classList.toggle("is-invalid", false);
        })
    );

// liens 'page précédente' ou 'refaire une simulation' :
document.querySelectorAll('.step-back-link')
    .forEach(button =>
        button.addEventListener("click", () => {
            if (currentIndex === initialIndex) {
                window.history.back();
            } else {
                hideStep(currentStepId);
                if (currentStepId === 'resultats') {
                    fromXSell = false;
                    if (initialIndex === -1) {
                        selectedOfferId = undefined;
                    }
                    initialisation();
                } else {
                    currentIndex--;
                    currentStepId = (currentIndex === -1)
                        ? currentStepId = dto.stepsList[0].id
                        : currentStepId = currentSequence[currentIndex];
                    showStep(currentStepId);
                }
            }
        })
    );

// switch options :
document.querySelectorAll('.js-options-switch')
    .forEach(switchButton => {
            switchButton.addEventListener("click", (event) => {
                event.preventDefault();
                const elementId = switchButton.dataset.elementId;
                if (optionStates[elementId] === false) {
                    // ajout
                    addOption(elementId);
                } else {
                    // suppression
                    removeOption(elementId);
                }
            });
        }
    );

// cta souscrire en ligne (= xSell) :
document.getElementById('onlineLink').addEventListener("click", (event) => {
    event.preventDefault();
    let queryParam = `?${dto.ctaBlock.onlineOfferParameter}=${selectedOffer.paramValue}`;
    if (discountCode) {
        queryParam += `&${dto.ctaBlock.onlineDiscountCodeParameter}=${discountCode}`;
    }
    if (optionsCounter > 0) {
        let firstArg = true;
        Object.keys(optionStates).forEach(elementId => {
            if (optionStates[elementId] === true) {
                const paramName = selectedOffer.options.find(op => op.elementId === elementId).paramName;
                if (firstArg === true) {
                    queryParam += `&${dto.ctaBlock.onlineOptionsParameter}=${paramName}`;
                    firstArg = false;
                } else {
                    queryParam += `,${paramName}`;
                }
            }
        });
    }
    const url = `${dto.ctaBlock.onlineRootUrl}${queryParam}&${dto.ctaBlock.onlineSourceParameter}=${dto.ctaBlock.simulatorSourceLabel}`;

    // gestion du retour arrière navigateur depuis la page xsell :
    const backUrl = `${dto.ctaBlock.simulatorRootUrl}${queryParam}&${dto.ctaBlock.onlineSourceParameter}=${dto.ctaBlock.xsellSourceLabel}`;
    window.history.replaceState('', '', backUrl);

    // gestion du tms :
    Tms.link(tmsTag('simulateur', 'souscrire', url));

    // on passe à la page xsell :
    window.location.href = url;
});

// code promo : clic sur la zone pour ajouter un code
discountCodeInputElement.addEventListener("click", (event) => {
    event.preventDefault();
    hideElement(discountCodeErrorElement);
    discountCodeInputElement.classList.remove('is-invalid')
    discountCodeInputElement.classList.remove('form-control-empty')
    discountCodeInputElement.classList.add('form-control-empty')
    showElement(discountCodeAddElement);
});

// code promo : clic sur le bouton 'ajouter' ou touche 'Entrée'
function codeInputListener(event) {
    event.preventDefault();
    const discountCodeInput = document.getElementById("discount-code-input").value;
    Tms.link(tmsTag(tmsLandingCategory, tmsDiscountCodeAction, 'ajouter'));
    addDiscountCode(discountCodeInput);
}

discountCodeAddElement.addEventListener("click", (event) => {
    codeInputListener(event);
});
discountCodeInputElement.addEventListener("keydown", function (event) {
    if (event.key === "Enter") codeInputListener(event);
});

// code promo : clic sur la croix 'Annuler'
discountCodeRemoveElement.addEventListener("click", (event) => {
    event.preventDefault();
    discountCode = null;
    const oldOfferPrice = offerPrice;
    const oldOfferInitialPrice = offerInitialPrice;

    initOfferPrice()

    totalPrice += offerPrice - oldOfferPrice;
    if (selectedOffer.hasDiscount) {
        totalPriceWithoutDiscount += offerInitialPrice - oldOfferInitialPrice;
    }
    updateTotalPrice();
    hideElement(discountCodeSpinnerElement);
    discountCodeInputElement.value = "";
    showElement(discountCodeAddElement);
    hideElement(discountCodeSuccessElement);
    showElement(discountCodeInputElement);

});

initialisation();

